import { render } from "./GoalScorersSerie.vue?vue&type=template&id=6f01c406"
import script from "./GoalScorersSerie.vue?vue&type=script&lang=js"
export * from "./GoalScorersSerie.vue?vue&type=script&lang=js"

import "./GoalScorersSerie.vue?vue&type=style&index=0&id=6f01c406&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__